export default function button() {
  return {
    _id: false,
    type: 'droplet.button',
    isShared: false,
    templateRegion: false,
    text: 'Button',
    successMsg: 'Success!',
    newWindow: false,
    pageLink: false,
    customLink: false,
    mediaQueries: [
      {
        global: true,
        selector: '.drzBtn-link',
        properties: [
          {
            defaultColor: true,
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'border-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'border-width',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'border',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'float',
            desktop: 'left',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'transform',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'margin',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzBtn',
        properties: [
          {
            property: 'color',
            desktop: 'rgba(255, 255, 255, 1)',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'padding-left',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'padding-right',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'padding-top',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'padding-bottom',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzBtn, .drzBtn-link',
        properties: [
          {
            property: 'border-radius',
            desktop: '1px',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    webhooks: [],
    bounceDroplet: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/button/droplet.schema.js